import React, { useState, useEffect } from 'react'
import { X, Upload } from 'lucide-react'
import './styles.scss'

export default function UniversityModal({ isOpen, onClose, onSave, initialData }) {
  const [formData, setFormData] = useState({ name: '', slug: '', website: '', logoUrl: '', country: '', state: '', city: '' })

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || '',
        slug: initialData.slug || '',
        website: initialData.website || '',
        logoUrl: initialData.logoUrl || '',
        country: initialData.country || '',
        state: initialData.state || '',
        city: initialData.city || ''
      })
    }
  }, [initialData])

  if (!isOpen) return null

  const handleLogoUpload = (e) => {
    const file = e.target.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onloadend = () => {
      setFormData({ ...formData, logoUrl: reader.result })
    }
    reader.readAsDataURL(file)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSave({ ...initialData, ...formData })
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '500px' }}>
        <div className="modal-header">
          <h2>Edit Organization</h2>
          <button className="icon-btn" onClick={onClose}><X size={20} /></button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label>University Logo</label>
            <div className="logo-upload-wrapper">
              <div className="logo-preview-circle">
                {formData.logoUrl ? (
                  <img src={formData.logoUrl} alt="Logo Preview" />
                ) : (
                  <span>🏢</span>
                )}
              </div>
              <div className="logo-upload-actions">
                <label className="btn btn-outline btn-sm">
                  <Upload size={14} style={{ marginRight: '6px' }} />
                  Upload New Logo
                  <input type="file" accept="image/*" style={{ display: 'none' }} onChange={handleLogoUpload} />
                </label>
                <p className="text-muted" style={{ fontSize: '12px', marginTop: '4px' }}>Recommended: 256x256px PNG/JPG</p>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>University Name</label>
            <input 
              type="text" 
              value={formData.name}
              onChange={e => setFormData({ ...formData, name: e.target.value })}
              required 
            />
          </div>

          <div className="form-group">
            <label>Organization Slug (Used for Magic Links)</label>
            <input 
              type="text" 
              value={formData.slug}
              onChange={e => setFormData({ ...formData, slug: e.target.value })}
              required 
            />
          </div>

          <div className="form-group">
            <label>Website</label>
            <input 
              type="url" 
              value={formData.website}
              placeholder="https://www.example.edu"
              onChange={e => setFormData({ ...formData, website: e.target.value })}
            />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem' }}>
            <div className="form-group">
              <label>Country</label>
              <input 
                type="text" 
                value={formData.country}
                onChange={e => setFormData({ ...formData, country: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>State/Province</label>
              <input 
                type="text" 
                value={formData.state}
                onChange={e => setFormData({ ...formData, state: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>City</label>
              <input 
                type="text" 
                value={formData.city}
                onChange={e => setFormData({ ...formData, city: e.target.value })}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-outline" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary">Save Changes</button>
          </div>
        </form>
      </div>
    </div>
  )
}
